import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export function useReports({ type, from = null, to = null } = {}) {
  const APIURL = `/reports?type=${type}&from=${from}&to=${to}`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}

export function useProfitLoss({ from = null, to = null } = {}) {
  const APIURL = `/reports/profit-loss?type=custom&from=${from}&to=${to}`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}

export function useItemizedProfitLoss({ type = "custom", from = null, to = null, fromTime = null, toTime = null } = {}) {
  const APIURL = `/reports/itemized-profit-loss?type=${type}&from=${from || ""}&to=${to || ""}&fromTime=${fromTime || ""}&toTime=${toTime || ""}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { dedupingInterval: 0, keepPreviousData: false });
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export function useTrialBalance({ from = null, to = null } = {}) {
  const APIURL = `/reports/trial-balance?from=${from || ""}&to=${to || ""}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { dedupingInterval: 0, keepPreviousData: false });
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export function useBalanceSheet({ asOfDate = null, from = null } = {}) {
  const APIURL = `/reports/balance-sheet?asOfDate=${asOfDate || ""}&from=${from || ""}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { dedupingInterval: 0, keepPreviousData: false });
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}


export function useLedgerReport({ from = null, to = null, account = null } = {}) {
  const APIURL = `/reports/ledger?type=custom&from=${from}&to=${to}${account ? `&accountType=${account}` : ""}`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher, { dedupingInterval: 0, keepPreviousData: false });
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}

export function useGenericReport({ reportType, dateFilter = "today", from = null, to = null } = {}) {
  const queryFrom = from || "";
  const queryTo = to || "";
  const APIURL = `/reports/generic/${reportType}?dateFilter=${dateFilter}&from=${queryFrom}&to=${queryTo}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { dedupingInterval: 0, keepPreviousData: false });
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}
export function useKOTReport({ dateFilter = "today", from = null, to = null } = {}) {
  const APIURL = `/reports/kot-report?type=${dateFilter}&from=${from}&to=${to}`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher);
  return { data, error, isLoading, APIURL };
}

export function useOrderDeletionReport({ dateFilter = "today", from = null, to = null } = {}) {
  const APIURL = `/reports/order-deletion-report?type=${dateFilter}&from=${from}&to=${to}`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher);
  return { data, error, isLoading, APIURL };
}

export function useDiscountsAndDeductionsReport({ dateFilter = "today", from = null, to = null } = {}) {
  const APIURL = `/reports/discounts-deductions?type=${dateFilter}&from=${from || ""}&to=${to || ""}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { dedupingInterval: 0, keepPreviousData: false });
  return { data, error, isLoading, mutate, APIURL };
}

